(function () {
    'use strict';
    angular.module('Services').factory('RoutingMatrixTableService', RoutingMatrixTableService);
    RoutingMatrixTableService.$inject = [
        'TableLiteFactory',
        'RoutingMatrixService',
        'toastr',
        '$uibModal',
        'ConfirmationModalFactory'
    ];

    function RoutingMatrixTableService(
        TableLiteFactory,
        RoutingMatrixService,
        toastr,
        $uibModal,
        ConfirmationModalFactory,
    ) {
        return function () {
            const deleteConfirmation = new ConfirmationModalFactory({}, {
                message: 'messages.warning.deleteRoutingMatrix.MESSAGE',
                code: 'messages.warning.deleteRoutingMatrix.CODE'
            });

            const tableData = {
                tableName: 'RoutingMatrixTable',
                config: {
                    noPagination: false,
                    noHeaders: false,
                    noItemsView: true,
                    noTableFooter: false
                },
                headers: [
                    {
                        label: 'ROUTE NAME',
                        viewName: 'routeName',
                        filterName: 'routeName',
                        filter: {
                            type: 'text',
                            placeholder: 'Search',
                            onSubmit: function (header) {
                                sendRequest(evaluateFilter(header));
                            }
                        },
                        headerFn: function () {
                            sort(this.filterName)
                        }
                    },
                    {
                        label: 'FROM ZONE',
                        viewName: 'fromZone',
                        filterName: 'fromZone',
                        filter: {
                            type: 'text',
                            placeholder: 'Search',
                            onSubmit: function (header) {
                                sendRequest(evaluateFilter(header));
                            }
                        },
                        headerFn: function () {
                            sort(this.filterName)
                        }
                    },
                    {
                        label: 'WAYPOINTS',
                        viewName: 'waypoints',
                        filterName: 'waypoints'
                    },
                    {
                        label: 'TO ZONE',
                        viewName: 'toZone',
                        filterName: 'toZone',
                        filter: {
                            type: 'text',
                            placeholder: 'Search',
                            onSubmit: function (header) {
                                sendRequest(evaluateFilter(header));
                            }
                        },
                        headerFn: function () {
                            sort(this.filterName)
                        }
                    },
                    {
                        label: 'BI-DIRECTIONAL',
                        viewName: 'biDirection',
                        filterName: 'biDirection',
                        filter: {
                            type: 'select2',
                            items: [
                                { viewName: 'YES', value: 'true' },
                                { viewName: 'NO', value: 'false' }
                            ],
                            placeholder: 'Search',
                            onSubmit: function (header) {
                                const filter = {};
                                filter[header.filterName] = header.filter.model;
                                sendRequest(filter);
                            }
                        },
                        headerFn: function () {
                            sort(this.filterName)
                        }
                    },
                    {
                        label: 'STATUS',
                        viewName: 'status'
                    },
                    {
                        label: 'ACTIONS',
                        viewName: 'actions',
                    }
                ],
                resetFilters: () => {
                    tableActions.resetFilters();
                },
                data: []
            };

            const tableActions = new TableLiteFactory(tableData, {
                serviceCallback: RoutingMatrixService.routes.getAll,
                callbackFormat: ['success', 'error', 'filter'],
                postRequestCallback: data => {
                    buildTableData(data);
                },
                postRequestErrorCallback: err => {
                    buildTableData(null);
                    toastr.error(err);
                },
                defaultFilters: {
                    size: 20,
                    page: 0,
                    sort: 'id,desc'
                }
            });

            const sort = tableActions.sort;
            const evaluateFilter = tableActions.evaluateFilter;
            const sendRequest = tableActions.sendRequest;

            function buildTableData(data) {
                if (!data) { return tableData; }

                angular.forEach(data.content, (item) => {
                    item.id = item.id;
                    item.status = item.enabled ? 'ACTIVE' : 'INACTIVE';
                    item.routeName = item.name;
                    item.fromZone = item.fromZone.name;
                    item.toZone = item.toZone.name;
                    item.biDirection = item.biDirection ? 'YES' : 'NO';
                    item.waypoints = {
                        type: 'multiLine',
                        list: item.waypoints.map(waypoint => waypoint.name)
                    };
                    item.actions = {
                        type: 'button',
                        buttons: [
                            {
                                text: item.enabled ? 'Disable' : 'Enable',
                                class: item.enable ? 'btn-succecss' : 'btn-default',
                                action: (data) => {
                                    enableDisableRoute(data);
                                }
                            },
                            {
                                text: 'View',
                                class: 'btn-primary',
                                action: (data) => {
                                    showDetails(data);
                                }
                            },
                            {
                                text: 'Delete',
                                class: 'btn-danger',
                                action: (data) => {
                                    deleteRoute(data);
                                }
                            }
                        ]
                    };

                    tableData.data.push(item);
                });
            }

            function enableDisableRoute(route) {
                RoutingMatrixService.routes.update(data => {
                    const message = route.enabled ? 'Routing matrix enabled' : 'Routing matrix disabled';
                    toastr.success(message, 'Success');
                    tableActions.sendRequest({});
                }, error => {
                    toastr.error(error.message, 'Error');
                }, RoutingMatrixService.routes.payloadMapper(route));
            }

            function deleteRoute(route) {
                deleteConfirmation.getInstance().result.then(cond => {
                    if (cond) {
                        RoutingMatrixService.routes.delete(success => {
                            toastr.success('Routing matrix data deleted', 'Success');
                            tableActions.sendRequest({});
                        }, error => {
                            toastr.error(error.message, 'Error');
                        }, route.id);
                    }
                });
            }

            function showDetails(route) {
                $uibModal.open({
                    animation: true,
                    ariaLabelledBy: 'modal-title',
                    ariaDescribedBy: 'modal-body',
                    templateUrl: '/templates/pages/routing-matrix/routing-matrix-modal.html',
                    controller: 'RoutingMatrixDetailsModalController',
                    controllerAs: 'vm',
                    size: 'md',
                    keyboard: false,
                    backdrop: 'static',
                    appendTo: $('body'),
                    resolve: {
                        id: () => { return route.id; }
                    }
                });
            }

            this.tableData = tableData;
        }
    }
})();


// WEBPACK FOOTER //
// ./js/services/tables/RoutingMatrixTableService.js